import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import { useLayoutFormSelections } from '../../hooks/useLayoutFormSelections';

import { ScreenAiSayStyles } from './AiSay.styles';

export const ScreenAiSay: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'AiSay',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const { ageGeneration, bodyShape, hairColor } = useLayoutFormSelections();

  React.useEffect(() => {
    preloadImage(
      `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai-second/${ageGeneration}/${bodyShape}/${hairColor}/chat_initiative.jpg`,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  return (
    <ScreenAiSayStyles
      background="dark-violet"
      bgImage={
        <img
          src={`https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai-second/${ageGeneration}/${bodyShape}/${hairColor}/ai_say.jpg`}
          alt="Ai say"
        />
      }
    >
      <IonContent>
        <div className="image-container">
          <img
            src={`https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai/ai-say-text.png`}
            alt="Ai say"
          />
        </div>
      </IonContent>

      <OnboardingFooter
        buttonColor="pink"
        onContinue={handleNextStep}
        buttonText="Let's go!"
      />
    </ScreenAiSayStyles>
  );
};
